module.exports = __webpack_public_path__ + "img/img20.8b024658.png";